export const overlayCoordinates = (coord: {
  min: { x: number; y: number };
  max: { x: number; y: number };
}) => ({
  x: coord.min.x,
  y: coord.min.y,
  width: coord.max.x - coord.min.x,
  height: coord.max.y - coord.min.y,
});
